module.exports = __webpack_public_path__ + "img/127-lion-dance-lying-down.15d805d.jpg";